import React from 'react';
import Tippy from '@tippy.js/react';
import styled from '@emotion/styled';

type Props = {
  mode: 'light' | 'dark',
  content: string,
  children: React.Node,
  className: ?string,
  touch: boolean,
  onCreate?: Function
};

export const Tooltip = ({ className, mode, content, touch, children, onCreate }: Props) => (
  <Wrapper arrow mode={mode} content={content} className={className} onCreate={onCreate} touch={touch}>
    {children}
  </Wrapper>
);

const Wrapper = styled(Tippy, { shouldForwardProp: prop => prop !== 'mode' })`
  padding: 8px 16px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: ${({ theme }) => theme.fontSize.sm};

  ${({ theme, mode }) =>
    mode === 'dark' &&
    `
    background: ${theme.color.white};
    color: ${theme.color.black};

    &[x-placement^='top'] {
      .tippy-arrow {
        border-top-color: ${theme.color.white};
      }
    }

    &[x-placement^='left'] {
      .tippy-arrow {
        border-left-color: ${theme.color.white};
      }
    }

    &[x-placement^='right'] {
      .tippy-arrow {
        border-right-color: ${theme.color.white};
      }
    }

    &[x-placement^='bottom'] {
      .tippy-arrow {
        border-bottom-color: ${theme.color.white};
      }
    }
  `}

  ${({ theme, mode }) =>
    mode === 'light' &&
    `
      background: ${theme.color.black};
      color: ${theme.color.white};

      &[x-placement^='top'] {
        .tippy-arrow {
          border-top-color: ${theme.color.black};
        }
      }

      &[x-placement^='left'] {
        .tippy-arrow {
          border-left-color: ${theme.color.black};
        }
      }

      &[x-placement^='right'] {
        .tippy-arrow {
          border-right-color: ${theme.color.black};
        }
      }

      &[x-placement^='bottom'] {
        .tippy-arrow {
          border-bottom-color: ${theme.color.black};
        }
      }
  `}
`;

Tooltip.defaultProps = {
  mode: 'light',
  touch: true,
};
